import Vue from 'vue'
import Vuex from 'vuex'
import products from './modules/products.js'
import agreements from './modules/agreements.js'
import menu from './modules/menu.js'
import user from './modules/user.js'
import config from './modules/config.js'
import profile from './modules/profile.js'
import subscriptions from './modules/subscriptions.js'
import epsProviders from './modules/epsProviders.js'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    products,
    agreements,
    user,
    menu,
    config,
    profile,
    subscriptions,
    epsProviders
  },
  strict: debug
})
